import { active } from "@api/stores/warehouses/active/api";
import { batches } from "@api/stores/warehouses/batches/api";
import { bulkAssignUsers } from "@api/stores/warehouses/bulkAssignUsers/api";
import { circulationEvents } from "@api/stores/warehouses/circulationEvents/api";
import { deactive } from "@api/stores/warehouses/deactive/api";
import { enterUnits } from "@api/stores/warehouses/enterUnits/api";
import { productBatchLocations } from "@api/stores/warehouses/productBatchLocations/api";
import { products } from "@api/stores/warehouses/products/api";
import { returnUnitsFromScraps } from "@api/stores/warehouses/returnUnitsFromScraps/api";
import { scrapUnits } from "@api/stores/warehouses/scrapUnits/api";
import { shelves } from "@api/stores/warehouses/shelves/api";
import { stats } from "@api/stores/warehouses/stats/api";
import { transferUnits } from "@api/stores/warehouses/transferUnits/api";
import { unassignUser } from "@api/stores/warehouses/unassignUser/api";
import { withdrawUnits } from "@api/stores/warehouses/withdrawUnits/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IWarehouseDto,
  IWarehouseGetAllParams,
  IWarehouseResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IWarehouseResponse>>,
  IPathBaseParam,
  IPaginationParams & IWarehouseGetAllParams
>("stores.warehouses");
const postApis = createPostApi<
  IApiResponse<IWarehouseResponse>,
  IPathBaseParam,
  IWarehouseDto
>("stores.warehouses");
const getApis = createGetApi<
  IApiResponse<IWarehouseResponse>,
  IPathByIdParam,
  object
>("stores.warehouses");
const patchApis = createPatchApi<
  IApiResponse<IWarehouseResponse>,
  IPathByIdParam,
  IWarehouseDto
>("stores.warehouses");

export const warehouses = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  active,
  deactive,
  stats,
  bulkAssignUsers,
  unassignUser,
  shelves,
  products,
  batches,
  productBatchLocations,
  circulationEvents,
  withdrawUnits,
  enterUnits,
  transferUnits,
  scrapUnits,
  returnUnitsFromScraps,
};
